import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppConfigSettings } from 'app/core/models/app-config';
import { TranslateModule } from '@ngx-translate/core';
import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

const CONFIG_FILE_NAME = '/assets/config.json';

fetch(CONFIG_FILE_NAME)
    .then(response => response.json() as Promise<AppConfigSettings>)
    .then(configSettings => {
        const configData = appConfig(configSettings);
        bootstrapApplication(AppComponent, {
            ...configData,
            providers: [
                ...(configData.providers || []),
                importProvidersFrom(
                  TranslateModule.forRoot({
                    loader: provideTranslateHttpLoader({
                      prefix: './assets/i18n/',
                      suffix: '.json'
                    })
                  })
                )
            ]
        }).catch(err => {
            console.error('Bootstrap failed:', err);
            throw err;
        });
    })
    .catch(err => console.error(`Error loading "${CONFIG_FILE_NAME}" before bootstrap.`, err));